import { IconChevron } from '@components/icons/icon-chevron';
import { Club } from '@domain/club';
import classNames from 'classnames';

export const MenuVenueButton = ({ clubState, showClubSubmenu }: { clubState: Club; showClubSubmenu: boolean }) => {
  return (
    <div className='flex flex-col static lg:relative self-start ml-auto'>
      <div className='cursor-pointer'>
        <span className='flex flex-row lg:self-end lg:static items-center gap-2'>
          <span className='flex gap-2 rounded-full border-2 border-extra-soft items-center p-0.5 bg-transparent'>
            <img className='w-8 h-8 rounded-full' src={clubState.logoUrl} alt='club' />
          </span>
          <span className='hidden lg:block lg:max-w-24 xl:max-w-32 2xl:max-w-52 text-body-xs text-secondary text-left truncate'>
            {clubState.name}
          </span>
          <IconChevron
            className={classNames('w-4 h-4 text-secondary', {
              'rotate-90': showClubSubmenu,
              '-rotate-90': !showClubSubmenu,
            })}
          />
        </span>
      </div>
    </div>
  );
};
